


export default function CorrectIcon(){
    return (<i className="fa-solid fa-circle-check" style={{color: "#3FBF48"}}></i>)
}